import { render } from "./App.vue?vue&type=template&id=59e9f862"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=59e9f862&lang=less"

import exportComponent from "/Users/binyu/fe/eshop-vant4-vue3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__